import { render, staticRenderFns } from "./DestructiveButton.vue?vue&type=template&id=edace3d0"
import script from "./DestructiveButton.vue?vue&type=script&lang=js"
export * from "./DestructiveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports